import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

export const API_PERSON_TOKEN = `/v4/b2c/people/auth`;
export const API_USER_HMAC = (app: string) => `/v3/utils/hmac/${app}`;
export const API_SEND_SICK_NOTE_PENDING = `/v4/b2c/sick_notes/pending`;
export const API_SEND_SICK_NOTE_FILLED = `/v4/b2c/sick_notes/filled`;
// DEV-1501: v6 multipart intake on closecare-apis-services. Selected by the
// FF resolver in sick-note.service.ts when newDocumentApi is on for the
// tenant. company_id is no longer in the URL — backend derives it from the
// JWT, same as v4. Only the version number and the hyphen separator
// (sick-notes vs sick_notes) differ from v4. The multipart/form-data
// contract (and the 409 duplicate response) must match v4 in
// closecare-apis-services before enabling the flag in prod.
export const API_SEND_SICK_NOTE_PENDING_V6 = `/v6/b2c/sick-notes/pending`;
export const API_SEND_SICK_NOTE_FILLED_V6 = `/v6/b2c/sick-notes/filled`;
export const API_READ_QRCODE = `/v4/b2c/utils/sick_notes/qrcode`;
export const API_GET_SICK_NOTE = (shortId: string) => `/v4/b2c/sick_notes/${shortId}`;
export const API_SETTINGS = `/v4/b2c/settings`;
export const API_PROFESSIONALS = (codeNumber: string, state: string) => `/v4/professionals/${codeNumber}/${state}`;
export const API_DOC_TYPES = `/v4/b2c/sick_notes_types`;
export const API_SEARCH_ICDS = `/v4/b2c/search/icds`;

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private httpClient: HttpClient) {}

  get http(): HttpClient {
    return this.httpClient;
  }
}
